import React from 'react';
import { Plugins } from '@leverege/plugin';
import SearchPopupRenderer from "./SearchPopupRenderer.js";
const {
  render
} = SearchPopupRenderer;

// eslint-disable-next-line import/prefer-default-export
export const SearchRendererFactory = Plugins.createFactory('SearchRenderer', {
  strategy: Plugins.reactStrategy(React, 'type'),
  pluginKey: 'render',
  defaultObject: render
});